<template>
	<!-- 编辑界面 -->
	<el-drawer :visible.sync="editFormVisible" :title="title" :size="600" :wrapper-closable="false" :modal="false" :destroy-on-close="true" class="margin_top_40" @click="closeDialog">
		<el-form ref="editForm" label-width="8.75rem" :model="editForm" :rules="rules">
			<el-form-item label="年月" prop="dateStr">
				<el-date-picker
					v-model="editForm.dateStr"
					type="month"
					value-format="yyyy-MM"
					format="yyyy年MM月"
					size="small"
					:picker-options="pickerOptions"
					class="input_200px"
					:clearable="false"
					:disabled="isEdit"
					@change="handleDateChange"
				></el-date-picker>
			</el-form-item>
			<el-form-item label="门店：" prop="storeKeyId">
				<el-select v-model="editForm.storeKeyId" placeholder="请选择门店" filterable size="small" class="input_200px" :disabled="isEdit" @change="handleChangeStore">
					<el-option v-for="item in storeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="员工：" prop="userKeyId">
				<el-select v-model="editForm.userKeyId" placeholder="请选择员工" clearable size="small" class="input_200px" :disabled="isEdit">
					<el-option v-for="item in userList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="学校提成" prop="schoolBonus">
				<el-input v-model.number="editForm.schoolBonus" placeholder="请输入学校提成" :min="0" clearable size="small" class="input_200px"></el-input>
			</el-form-item>
			<el-form-item label="应扣除金额" prop="subtractMoney">
				<el-input v-model.number="editForm.subtractMoney" placeholder="请输入应扣除金额" :min="0" clearable size="small" class="input_200px"></el-input>
			</el-form-item>
			<el-form-item label="目标达成奖励" prop="finishedMoney">
				<el-input v-model.number="editForm.finishedMoney" placeholder="请输入目标达成奖励" :min="0" clearable size="small" class="input_200px"></el-input>
			</el-form-item>
			<el-form-item label="补发金额" prop="reissueMoney">
				<el-input v-model.number="editForm.reissueMoney" placeholder="请输入补发金额" :min="0" clearable size="small" class="input_200px"></el-input>
			</el-form-item>
			<el-form-item label="销售递增奖励" prop="salesIncreasing">
				<el-input v-model.number="editForm.salesIncreasing" placeholder="请输入销售递增奖励" :min="0" clearable size="small" class="input_200px"></el-input>
			</el-form-item>
			<el-form-item label="备注">
				<el-input v-model="editForm.remark" placeholder="请输入备注" clearable type="textarea" rows="3" size="small" class="input_200px"></el-input>
			</el-form-item>
		</el-form>
		<div class="drawer-footer">
			<el-button size="small" icon="el-icon-check" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
		</div>
	</el-drawer>
</template>

<script>
import { SaveUserMonthSalary, GetUserMonthSalaryDetail } from "@/api/salaryApi.js";
import { GetUserBindSelectByPermission } from "@/api/userApi.js";
import { GetOrgInfoListByConfig } from "@/api/organizationalApi.js";
export default {
	data() {
		return {
			title: "",
			isEdit: false, //是否是编辑
			loading: false, //是显示加载
			editFormVisible: false, //控制编辑页面显示与隐藏
			editForm: {
				keyId: "",
				year: new Date().getFullYear(),
				month: new Date().getMonth() + 1,
				storeKeyId: "",
				userKeyId: "",
				remark: "",
				schoolBonus: 0,
				subtractMoney: 0,
				finishedMoney: 0,
				reissueMoney: 0,
				salesIncreasing: 0,
				dateStr: ""
			},
			storeList: [],
			// rules 表单验证
			rules: {
				dateStr: [
					{
						required: true,
						message: "请选择年月",
						trigger: "blur"
					}
				],
				storeKeyId: [
					{
						required: true,
						message: "请选择门店",
						trigger: "blur"
					}
				],
				userKeyId: [
					{
						required: true,
						message: "请选择员工",
						trigger: "blur"
					}
				],
				phoneBonus: [
					{
						validator: (rule, value, callback) => {
							if (value === undefined || value === null || value === "") {
								callback(new Error("请输入电话提成"));
							} else if (isNaN(Number(value))) {
								callback(new Error("电话提成必须是数字"));
							} else {
								callback();
							}
						},
						trigger: "blur"
					}
				],
				schoolBonus: [
					{
						validator: (rule, value, callback) => {
							if (value === undefined || value === null || value === "") {
								callback(new Error("请输入学校提成"));
							} else if (isNaN(Number(value))) {
								callback(new Error("学校提成必须是数字"));
							} else {
								callback();
							}
						},
						trigger: "blur"
					}
				],
				subtractMoney: [
					{
						validator: (rule, value, callback) => {
							if (value === undefined || value === null || value === "") {
								callback(new Error("请输入应扣除金额"));
							} else if (isNaN(Number(value))) {
								callback(new Error("应扣除金额必须是数字"));
							} else {
								callback();
							}
						},
						trigger: "blur"
					}
				],
				finishedMoney: [
					{
						validator: (rule, value, callback) => {
							if (value === undefined || value === null || value === "") {
								callback(new Error("请输入目标达成奖励"));
							} else if (isNaN(Number(value))) {
								callback(new Error("目标达成奖励必须是数字"));
							} else {
								callback();
							}
						},
						trigger: "blur"
					}
				],
				reissueMoney: [
					{
						validator: (rule, value, callback) => {
							if (value === undefined || value === null || value === "") {
								callback(new Error("请输入补发金额"));
							} else if (isNaN(Number(value))) {
								callback(new Error("补发金额必须是数字"));
							} else {
								callback();
							}
						},
						trigger: "blur"
					}
				],
				salesIncreasing: [
					{
						validator: (rule, value, callback) => {
							if (value === undefined || value === null || value === "") {
								callback(new Error("请输入销售递增奖励"));
							} else if (isNaN(Number(value))) {
								callback(new Error("销售递增奖励必须是数字"));
							} else {
								callback();
							}
						},
						trigger: "blur"
					}
				]
			},
			userList: [],
			pickerOptions: {
				disabledDate(time) {
					const now = new Date();
					// 设置为当前月份的第一天
					now.setDate(1);
					now.setHours(0, 0, 0, 0);

					// 计算一个月之前的日期
					const oneMonthAgo = new Date(now);
					oneMonthAgo.setMonth(now.getMonth() - 1);

					// 禁用所有早于一个月之前月份的日期
					return time.getTime() < oneMonthAgo.getTime();
				}
			}
		};
	},
	computed: {},
	watch: {},
	created() {
		this.GetOrgInfoListByConfig();
	},
	mounted() {},
	components: {},
	methods: {
		//显示编辑界面
		editShow(row) {
			if (row != undefined && row != "undefined") {
				this.title = "编辑";
				let parmer = {
					keyId: row.keyId
				};
				GetUserMonthSalaryDetail(parmer)
					.then((res) => {
						if (res.code == 1) {
							this.GetUserBindSelectByPermission(res.data.storeKeyId);
							this.editForm = res.data;
							this.editFormVisible = true;
							this.editForm.dateStr = this.editForm.year + "-" + this.editForm.month;
							this.isEdit = true;
						} else {
							this.$message.error(res.msg);
						}
					})
					.catch((err) => {
						this.$message.error("获取月度薪资详情失败!");
					});
			} else {
				this.title = "新增";
				this.$data.editForm = this.$options.data.call(this).editForm;
				this.editFormVisible = true;
				this.editForm.dateStr = this.editForm.year + "-" + this.editForm.month;
				this.isEdit = false;
			}
		},
		// 编辑、增加页面保存方法
		submitForm(editData) {
			this.$refs[editData].validate((valid) => {
				if (valid) {
					SaveUserMonthSalary(this.editForm)
						.then((res) => {
							if (res.code == 1) {
								this.$parent.getListData();
								this.$message({
									type: "success",
									message: "月度薪资保存成功！"
								});
								this.editFormVisible = false;
								this.loading = false;
							} else {
								this.$message({
									type: "error",
									message: res.msg
								});
							}
						})
						.catch((err) => {
							this.editFormVisible = false;
							this.loading = false;
							this.$message.error("月度薪资保存失败，请稍后再试！");
						});
				} else {
					return false;
				}
			});
		},
		// 获取所属门店
		GetOrgInfoListByConfig() {
			const paramer = {
				key: 1
			};
			GetOrgInfoListByConfig(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.storeList = [];
						res.data.forEach((item) => {
							this.storeList.push({
								keyId: item.keyId,
								value: item.name + "【" + item.remark2 + "】"
							});
						});
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取门店信息失败!");
				});
		},
		// 获取人员信息绑定下拉框_根据权限
		GetUserBindSelectByPermission(val) {
			const paramer = {
				keyId: val
			};
			GetUserBindSelectByPermission(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.userList = [];
						if (res.code == 1) {
							this.userList = res.data;
						} else {
							this.$message.error(res.msg);
						}
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取人员信息失败!");
				});
		},
		// 关闭编辑、增加弹出框
		closeDialog() {
			this.editFormVisible = false;
			this.$data.editForm = this.$options.data.call(this).editForm;
		},
		// 门店选择改变时触发
		handleChangeStore(val) {
			this.editForm.userKeyId = "";
			this.GetUserBindSelectByPermission(val);
		},
		// 年月选择改变时触发
		handleDateChange(val) {
			if (val.length > 0) {
				var list = val.split("-");
				this.editForm.year = parseInt(list[0]);
				this.editForm.month = parseInt(list[1]);
			} else {
				this.editForm.year = new Date().getFullYear();
				this.editForm.month = new Date().getMonth() + 1;
			}
			this.editForm.dateStr = val;
		}
	}
};
</script>
<style scoped>
.wip {
	width: 200px !important;
}
</style>
